module.exports = __webpack_public_path__ + "media/src/assets/images/logo-light-51d2b894bfb14e998b82ce744475f6d3.svg";